const INITIAL_STATE = {
  opened: false,
};

export default function LeftSidebarReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'TOGGLED':
    case 'OPENED':
    case 'CLOSED':
      return { ...state, opened: action.payload };
    default:
      return state;
  }
}
